var map = {
	"./vegyes10.PNG": 6527,
	"./vegyes11.PNG": 918,
	"./vegyes12.PNG": 4813,
	"./vegyes13.PNG": 8468,
	"./vegyes14.PNG": 9995,
	"./vegyes15.PNG": 290,
	"./vegyes16.PNG": 3849,
	"./vegyes17.PNG": 8240,
	"./vegyes18.PNG": 4343,
	"./vegyes19.PNG": 4110,
	"./vegyes2.PNG": 8180,
	"./vegyes20.PNG": 2894,
	"./vegyes21.PNG": 3319,
	"./vegyes22.PNG": 9132,
	"./vegyes23.PNG": 7506,
	"./vegyes24.PNG": 5850,
	"./vegyes3.PNG": 4109,
	"./vegyes4.PNG": 3330,
	"./vegyes5.PNG": 4347,
	"./vegyes6.PNG": 5824,
	"./vegyes7.PNG": 5945,
	"./vegyes8.PNG": 382,
	"./vegyes9.PNG": 807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3539;